/* eslint-disable */

/*
 * This is a generated file created by deere-ui-svg-to-react.
 *
 * Please do not modify this file directly as it will be regenerated at build time.
 */

"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

exports["default"] = _react2["default"].createClass({
    displayName: "wrench",

    getDefaultProps: function getDefaultProps() {
        return {
            "st0": {
                "fill": "#676767"
            },
            "wrench": {
                "backgroundImage": "none",
                "backgroundPosition": "0% 0%",
                "display": "inline",
                "fill": "#333"
            },
            "width": "24",
            "height": "24"
        };
    },

    render: function render() {
        return _react2["default"].createElement(
            "svg",
            { id: "Layer_1", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24", className: "wrench", width: this.props.width, height: this.props.height, style: this.props.wrench },
            _react2["default"].createElement("path", { className: "st0", d: "M1 22.9c-1.4-1.6-.9-2.5-.9-2.5L12.4 8.2c-.2-.6-.4-1.1-.4-1.7 0-.5 0-1.1.1-1.7.1-.6.3-1.1.6-1.6s.6-1 1.1-1.4c.4-.4.8-.7 1.3-1 .5-.3 1-.5 1.5-.6.5-.1 1-.2 1.5-.2s1 .1 1.5.2L15 4.9 19.1 9l4.6-4.6c.1.5.2 1 .2 1.5s0 1-.2 1.5c-.1.5-.3 1-.6 1.5s-.6.9-1 1.3-.9.8-1.4 1.1c-.5.3-1.1.5-1.6.6s-1.1.1-1.7 0c-.6-.1-1.1-.2-1.7-.4L3.3 23.9s-1 .5-2.3-1z", style: this.props.st0 })
        );
    }
});

/* eslint-enable */
module.exports = exports["default"];



// WEBPACK FOOTER //
// ./~/cap-it-ui.toggles/~/cap-it-ui.icons/lib/wrench.js